export { default } from './FootprintResults'
